export default __webpack_public_path__ + "static/media/2 alt.f571c28b.webp";